module.exports = __webpack_public_path__ + "img/sidelogowhite.b5d8506c.png";